module.exports = __webpack_public_path__ + "img/aab_logo_min.8e6a0da7.jpg";